import { ResponseRepresentationUserBenefitsRepresentation } from "src/app/api/smart-pensjon-rest-api/models";

/** `hasBenefits: false` keeps the dashboard benefits link hidden offline, as today. */
export function generateMockUserBenefits(): ResponseRepresentationUserBenefitsRepresentation {
  return { payload: { hasBenefits: false } };
}
